import { render, staticRenderFns } from "./LayoutManager.vue?vue&type=template&id=53570b10&"
import script from "./LayoutManager.vue?vue&type=script&lang=js&"
export * from "./LayoutManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports